import React, { useState } from "react";
import Moment from "moment";
import { safeFetch } from '../../../utils/security';
import Icon from "components/blocks/Icon/Icon";
import "./Cards.scss";

const PAGE_SIZE = 5;

const GeneralDocumentsGrid = ({ documents }) => {
  const [page, setPage] = useState(1);

  const totalPages = Math.ceil(documents.length / PAGE_SIZE);
  const safePage = Math.min(page, totalPages || 1);
  const paged = documents.slice((safePage - 1) * PAGE_SIZE, safePage * PAGE_SIZE);

  const downloadFile = async (url, nombre) => {
    try {
      const response = await safeFetch(url);
      if (!response.ok) throw new Error("No se pudo descargar el archivo");
      const blob = await response.blob();
      const urlBlob = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = urlBlob;
      a.download = nombre.endsWith(".pdf") ? nombre : nombre + ".pdf";
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(urlBlob);
    } catch (error) {
      console.error("Error al descargar el archivo:", error);
    }
  };

  return (
    <div>
      <div className="cards-list">
        {paged.map((doc, i) => {
          const nombre = doc.Nombre ?? doc.nombre ?? "";
          const uri    = doc.Uri    ?? doc.uri    ?? "";
          const fecha  = doc.Fecha  ?? doc.fecha  ?? null;

          return (
            <article key={i} className="item-card item-card--compact">
              <div className="item-card__icon">
                <Icon name="file-text" size={22} />
              </div>
              <div className="item-card__content">
                <div className="item-card__title">{nombre}</div>
                <div className="item-card__meta">
                  <span className="item-card__sub">PDF</span>
                  {fecha && (
                    <span className="item-card__sub">
                      {Moment(fecha).format("DD MMM YYYY")}
                    </span>
                  )}
                </div>
              </div>
              <div className="item-card__action">
                <button
                  className="item-card__download-btn"
                  onClick={() => downloadFile(uri, nombre)}
                  title="Descargar"
                >
                  <Icon name="download" size={14} />
                  Descargar
                </button>
              </div>
            </article>
          );
        })}
      </div>

      <div className="comms-list__pager" style={{ visibility: totalPages > 1 ? "visible" : "hidden" }}>
        <button
          className="comms-list__pager-btn"
          disabled={safePage === 1}
          onClick={() => setPage(safePage - 1)}
        >
          ‹ Anterior
        </button>
        <span className="comms-list__pager-info">
          {safePage} / {totalPages}
        </span>
        <button
          className="comms-list__pager-btn"
          disabled={safePage === totalPages}
          onClick={() => setPage(safePage + 1)}
        >
          Siguiente ›
        </button>
      </div>
    </div>
  );
};

export default GeneralDocumentsGrid;
